<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="sw-dialog"
      @mousedown.self="$emit('close')"
    >
      <div
        class="sw-dialog__card"
        role="dialog"
        aria-modal="true"
      >
        <header class="sw-dialog__head">
          <h3>{{ title }}</h3>
          <button type="button" class="sw-dialog__close" title="Fechar" @click="$emit('close')">
            <i class="bi bi-x-lg"></i>
          </button>
        </header>
        <div class="sw-dialog__body">
          <slot />
        </div>
        <footer v-if="$slots.footer" class="sw-dialog__foot">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ScheduleDialog',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  emits: ['close'],
  watch: {
    open: {
      immediate: true,
      handler(value) {
        document.body.classList.toggle('sw-dialog-lock', Boolean(value));
      },
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKey);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKey);
    document.body.classList.remove('sw-dialog-lock');
  },
  methods: {
    onKey(event) {
      if (this.open && event.key === 'Escape') this.$emit('close');
    },
  },
};
</script>

<style>
.sw-dialog-lock {
  overflow: hidden;
}
</style>

<style scoped>
.sw-dialog {
  --sw-brand: #780f5a;
  --sw-line: #e4e6ef;
  --sw-muted: #7e8299;
  --sw-ink: #181c32;
  --sw-soft: #f8f5f7;
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: rgba(24, 28, 50, 0.38);
}
.sw-dialog__card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 0.85rem;
  box-shadow: 0 18px 48px rgba(24, 28, 50, 0.18);
}
.sw-dialog__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1rem 0.55rem;
}
.sw-dialog__head h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: #181c32;
}
.sw-dialog__close {
  appearance: none;
  flex-shrink: 0;
  width: 2.1rem;
  height: 2.1rem;
  margin: 0;
  padding: 0;
  border: 1px solid #e4e6ef;
  border-radius: 0.5rem;
  background: #fff;
  color: #7e8299;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: none;
}
.sw-dialog__close i {
  font-size: 0.85rem;
  line-height: 1;
}
.sw-dialog__close:hover {
  border-color: #780f5a;
  color: #780f5a;
  background: #f8f5f7;
}
.sw-dialog__body {
  padding: 0.35rem 1rem 0.5rem;
}
.sw-dialog__foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
  padding: 0.65rem 1rem 0.95rem;
}
</style>
